import { LogoIcon } from '../../icons/logo.icon';
import { Title } from '../title/title.component';
import { type Style, mergeStyle } from './brand.module.css';

interface Props { 
  style?: Style;
}

export function Brand(props: Props) {

  const { 
    style: customStyle
  } = props;

  const style = mergeStyle(customStyle);

  return (
    <div className={style.container}>
      <LogoIcon/>
      <Title
        style={style.title}
        title='Recargas Dominicanas'/>
    </div>
  );
}
